import { mixinStyles } from '@project/mixin'
import stylesOrigin from '@/components/modules/Lines/Lines.scss'
import styles from '@project/components/modules/Lines/Lines.scss'

function ModuleOptions() {
  return null
}

__EXEC(() => {
  mixinStyles(stylesOrigin, styles)
})

__OVERRIDE(styles)

__OVERRIDE(ModuleOptions)
